import { IconPhoto } from "@tabler/icons-react";

const ImageMissing = () => {
  return <IconPhoto stroke={0.25} className="size-full text-base-300" />;
};
export default ImageMissing;
